var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPositionUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-inline--fa fa-arrow-alt-circle-up fa-w-16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_11",
    fill: "none",
    d: "m3.467081,0.609907l506.494414,0l0,510.780145l-506.494414,0l0,-510.780145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee7621",
    stroke: "null",
    id: "svg_12",
    d: "m256.714287,171.843962c-46.639693,0 -84.415735,37.979455 -84.415735,84.870289s37.776042,84.870289 84.415735,84.870289s84.415736,-37.979454 84.415736,-84.870289s-37.776042,-84.870289 -84.415736,-84.870289zm188.66917,63.652717c-9.70781,-88.477276 -79.561831,-158.70744 -167.565236,-168.467523l-42.207867,0c-88.003405,9.760083 -157.857426,79.990247 -167.565236,168.467523l0,42.435145c9.70781,88.477276 79.561831,158.70744 167.565236,168.467523l42.207867,0c88.003405,-9.760083 157.857426,-79.990247 167.565236,-168.467523l0,-42.435145zm-188.66917,169.740578c-81.672224,0 -147.727537,-66.411001 -147.727537,-148.523006s66.055313,-148.523005 147.727537,-148.523005s147.727538,66.411001 147.727538,148.523005s-66.055313,148.523006 -147.727538,148.523006z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositionUser);
export default __webpack_public_path__ + "static/media/icon-position-user.7b17557144b752b409658794669956a4.svg";
export { ForwardRef as ReactComponent };